import type { IndividualAdditionalData } from ".";
import type { RegisterItemList } from "@services/registers/list/type";
import type { SampleItemList } from "@services/samples/list/type";

export const EventAdditionalDataColumns: Array<{
  id: keyof IndividualAdditionalData;
  label: string;
}> = [
  { id: "createdAt", label: "Data e Hora" },
  { id: "registeredBy", label: "Registrado por" },
  { id: "attachmentsNumber", label: "Nº de Anexos" },
];

export const EventRegisterColumns: Array<{
  id: keyof RegisterItemList;
  label: string;
}> = [
  { id: "type", label: "Tipo de Registro" },
  { id: "registerDate", label: "Data e Hora" },
  { id: "environment", label: "Ambiente" },
  { id: "reporterName", label: "Reportado por" },
  { id: "attachmentsCount", label: "Nº de Anexos" },
];

export const EventSampleColumns: Array<{
  id: keyof SampleItemList;
  label: string;
}> = [
  { id: "type", label: "Tipo de Amostra" },
  { id: "sampleDate", label: "Data e Hora" },
  { id: "reporterName", label: "Reportado por" },
  { id: "attachmentsCount", label: "Nº de Anexos" },
];
